module.exports = __webpack_public_path__ + "static/media/money-team.e5a7d483.png";